'use client'

import Messages from '@/constants/Messages'
import { AppState } from '@/lib/store'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

const ContactUsForDiamond = ({ is_gemstone }: { is_gemstone: boolean }) => {
  const { settingOptions } = useSelector((state: AppState) => state.settings)
  const [contactUs, setContactUs] = useState<any>({
    phone: '',
    email: ''
  })
  useEffect(() => {
    if (settingOptions?.length > 0) {
      setContactUs({
        phone: settingOptions.filter((item: any) => item.hj_key === Messages.CustomerCareNumber)[0]
          .hj_value,
        email:
          settingOptions.filter((item: any) => item.hj_key === Messages.CustomerSupportEmail)[0]
            ?.hj_value ?? ''
      })
    }
  }, [settingOptions])
  return (
    <div className="mb-3 my-1 detail-callus-contact">
      <div className="gap-3">
        {/* Left Section */}
        <div className="mb-2">
          <div>
            Need help picking the {is_gemstone ? 'gemstone' : 'diamond'}?{' '}
            <span className="fw-semibold">Call us now — we’ll guide you.</span>
          </div>
        </div>
        <div className="d-flex flex-wrap gap-2 gap-lg-3">
          <a
            href={`tel:${contactUs.phone}`}
            className="d-flex align-items-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#535353"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-phone me-1"
            >
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
            </svg>
            {contactUs.phone ? contactUs.phone : ' '}
          </a>
          <a
            href={`mailto:${contactUs.email}`}
            className="d-flex align-items-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#535353"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-mail me-1"
            >
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
              <polyline points="22,6 12,13 2,6"></polyline>
            </svg>
            {contactUs.email ? contactUs.email : ' '}
          </a>
        </div>
      </div>
    </div>
  )
}
export default ContactUsForDiamond
